import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isSidebarCollapsed: false,
};

export const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setSidebarCollapsed(state, { payload }) {
      state.isSidebarCollapsed = payload;
    },
  },
});

export const { setSidebarCollapsed } = uiSlice.actions;
export default uiSlice.reducer;
